module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/suns_sns_06-69dd951dd90fbda1434461ee2498fbf3.jpg";